import React, { ReactElement, useRef } from 'react';

import styles from './SelectableTag.module.scss';
import classNames from 'classnames';
import { Tag } from '../../../../state/types';
import InfoTooltip from 'utils/components/info-tooltip';

interface SelectableTagProps {
  tag: Tag;
  label: string;
  tooltip?: string;
  isSelected: boolean;
  onClick: (tag: Tag) => void;
}

interface InfoTooltipApi {
  show: () => void;
  hide: () => void;
}

export const SelectableTag = (props: SelectableTagProps): ReactElement => {
  const { tag, label, tooltip, isSelected, onClick } = props;

  const tagRef = useRef(null);
  const tooltipRef = useRef<InfoTooltipApi>(null);

  return (
    <span
      className={classNames(styles.selectableTag, { [styles.selected]: isSelected })}
      ref={tagRef}
      onClick={() => onClick(tag)}
      onMouseEnter={() => {
        if (tooltipRef.current) {
          tooltipRef.current.show();
        }
      }}
      onMouseLeave={() => {
        if (tooltipRef.current) {
          tooltipRef.current.hide();
        }
      }}
    >
      {tooltip && (
        <InfoTooltip
          className={styles.tooltipInfo}
          ref={tooltipRef}
          alignElement={() => tagRef.current}
          direction={'bottom'}
        >
          <span className={'text'}>{tooltip}</span>
        </InfoTooltip>
      )}
      {label}
    </span>
  );
};
